import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../Help/AxiosLogicInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { State, City } from "country-state-city"; // Import the package

// ...existing imports...

const stateMap = {
  "Andhra Pradesh": 1,
  "Arunachal Pradesh": 2,
  "Assam": 3,
  "Bihar": 4,
  "Chhattisgarh": 5,
  "Goa": 6,
  "Gujarat": 7,
  "Haryana": 8,
  "Himachal Pradesh": 9,
  "Jharkhand": 10,
  "Karnataka": 11,
  "Kerala": 12,
  "Madhya Pradesh": 13,
  "Maharashtra": 14,
  "Manipur": 15,
  "Meghalaya": 16,
  "Mizoram": 17,
  "Nagaland": 18,
  "Odisha": 19,
  "Punjab": 20,
  "Rajasthan": 21,
  "Sikkim": 22,
  "Tamil Nadu": 23,
  "Telangana": 24,
  "Tripura": 25,
  "Uttar Pradesh": 26,
  "Uttarakhand": 27,
  "West Bengal": 28,
  "Andaman and Nicobar Islands": 29,
  "Chandigarh": 30,
  "Dadra and Nagar Haveli and Daman and Diu": 31,
  "Delhi": 32,
  "Jammu and Kashmir": 33,
  "Ladakh": 34,
  "Lakshadweep": 35,
  "Puducherry": 36
};

const AcademicResearchForm = () => {
  const StudentId = localStorage.getItem("StudentId");
  const [loading, setLoading] = useState(false);

  // Add state for district options
  const [homeDistrictOptions, setHomeDistrictOptions] = useState([]);
  const [medicalCollegeDistrictOptions, setMedicalCollegeDistrictOptions] =
    useState([]);
  const [statesData, setStatesData] = useState([]);
  const [indianStates, setIndianStates] = useState([]);

  useEffect(() => {
    document.title = "Academic Research Application - MedEngage";
  }, []);

  useEffect(() => {
    const loadStatesData = async () => {
      try {
        const response = await fetch('/Districts/states_districts.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1); // Skip header
        const data = lines.map(line => {
          const [state, district] = line.split(',').map(s => s.replace(/"/g, '').trim());
          return { state, district };
        }).filter(item => item.state && item.district);
        setStatesData(data);
        const uniqueStates = [...new Set(data.map(item => item.state))].sort();
        setIndianStates(uniqueStates);
      } catch (error) {
        console.error('Error loading states data:', error);
      }
    };
    loadStatesData();
  }, []);
  const [formData, setFormData] = useState({
    applicantName: "",
    gender: "",
    contactNumber: "",
    altContact: "",
    email: "",
    hostAddress: "",
    homeState: "",
    homeDistrict: "",
    homeCity: "",
    passportPhoto: null,
    wonBefore: "",
    published: "",
    publicationLink: "",
    winnerName: "",
    winnerType: "",
    siblingWon: "",
    siblingName: "",
    siblingType: "",
    mentorName: "",
    mentorContact: "",
    mentorEmail: "",
    coInvestigatorName: "",
    coInvestigatorContact: "",
    coInvestigatorEmail: "",
    medicalCollegeName: "",
    medicalCollegeAddress: "",
    medicalCollegeState: "",
    medicalCollegeDistrict: "",
    medicalCollegeCity: "",
    medicalCollegePincode: "",
    bankName: "",
    branchName: "",
    accountNumber: "",
    ifscCode: "",
    bankAddress: "",
    panNumber: "",
    bankDocuments: null,
    panFile: null,
    agreeProgressReport: false,
    agreeAcknowledgement: false,
    agreeReturnFunds: false,
    agreeTerms: false,
    shareReport: "",
    acknowledge: "",
    refund: "",
    confirmDetails: false,
    researchCenter: "",
    approvalLetter: null,
    researchTitle: "",
    startDate: "",
    endDate: "",
    cases: "",
    studyType: "",
    studyDesign: null,
    coverLetter: null,
    researchTemplate: null,
    referenceArticle: null,
    ethicsLetter: null,
    budget: "",
    applicantCV: null,
    signature: null,
    referencePublication: null,
  });

  useEffect(() => {
    if (formData.homeState && statesData.length > 0) {
      const districts = statesData
        .filter(item => item.state === formData.homeState)
        .map(item => item.district)
        .sort();
      setHomeDistrictOptions(districts);
    } else {
      setHomeDistrictOptions([]);
    }
  }, [formData.homeState, statesData]);

  useEffect(() => {
    if (formData.medicalCollegeState && statesData.length > 0) {
      const districts = statesData
        .filter(item => item.state === formData.medicalCollegeState)
        .map(item => item.district)
        .sort();
      setMedicalCollegeDistrictOptions(districts);
    } else {
      setMedicalCollegeDistrictOptions([]);
    }
  }, [formData.medicalCollegeState, statesData]);

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  // ...handleChange and validate functions as before...

  function generateReferenceId() {
    const year = new Date().getFullYear();
    const random = Math.floor(1000 + Math.random() * 9000);
    return `#MED-${year}-${random}`;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (loading) return; // Prevent double submit

    // Complete list of all required fields
    const requiredFields = [
      // Basic information
      "applicantName",
      "gender",
      "contactNumber",
      "email",
      "homeState",
      "homeDistrict",
      "homeCity",
      "hostAddress",
      "passportPhoto",

      // Research guide/mentor information
      "mentorName",
      "mentorContact",
      "mentorEmail",
      "coInvestigatorName",
      "coInvestigatorContact",
      "coInvestigatorEmail",

      // Medical college details
      "medicalCollegeName",
      "medicalCollegeAddress",
      "medicalCollegeState",
      "medicalCollegeDistrict",
      "medicalCollegeCity",
      "medicalCollegePincode",

      // Research details
      "researchCenter",
      "approvalLetter",
      "researchTitle",
      "startDate",
      "endDate",
      "cases",
      "studyType",
      "studyDesign",
      "coverLetter",
      "researchTemplate",
      "referenceArticle",
      "ethicsLetter",
      "budget",
      "applicantCV",
      "signature",

      // Bank details
      "bankName",
      "branchName",
      "accountNumber",
      "ifscCode",
      "bankAddress",
      "panNumber",
      "bankDocuments",
      " panFile",

      // Agreements
      "shareReport",
      "acknowledge",
      "refund",
      "agreeTerms",
      "confirmDetails",
    ];

    // Check for undefined fields

    // Check for empty fields (null, empty string, etc)
    const emptyFields = requiredFields.filter(
      (field) =>
        formData[field] === "" ||
        formData[field] === null ||
        formData[field] === false
    );

    // Check for file fields specifically
    const fileFields = [
      "passportPhoto",
      "approvalLetter",
      "studyDesign",
      "coverLetter",
      "researchTemplate",
      "referenceArticle",
      "ethicsLetter",
      "applicantCV",
      "signature",
      "bankDocuments",
      "panFile",
    ];

    const missingFileFields = fileFields.filter((field) => !formData[field]);

    // Create a detailed validation report
    console.group("Detailed Form Validation Report");
    requiredFields.forEach((field) => {
      const status = formData[field] ? "✓ Present" : "✗ Missing";
      const value = fileFields.includes(field)
        ? formData[field]
          ? `File: ${formData[field].name}`
          : "No file selected"
        : formData[field];
      console.log(`${field}: ${status}`, value);
    });
    console.groupEnd();

    const isValid = validate();
    if (!isValid) {
      console.log("Validation errors:", errors);
      const firstErrorField = Object.keys(errors).find(
        (key) => errors[key] && fieldRefs[key]
      );

      if (firstErrorField && fieldRefs[firstErrorField]?.current) {
        fieldRefs[firstErrorField].current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        fieldRefs[firstErrorField].current.focus();

        // Improve error message - show what's missing instead of "undefined"
        const errorMessage = errors[firstErrorField];
        toast.error(
          `Please check the "${firstErrorField}" field - ${errorMessage}`
        );
      } else if (Object.keys(errors).length > 0) {
        // If there are errors but no matching field ref
        const firstError = Object.keys(errors)[0];
        toast.error(
          `Please check the "${firstError}" field - ${errors[firstError]}`
        );
      } else {
        toast.error("Please fill all required fields");
      }
      return;
    }

    // Map Gender string to int as per API
    let genderInt = 0;
    if (formData.gender === "Male") genderInt = 1;
    else if (formData.gender === "Female") genderInt = 2;
    else if (formData.gender === "Other") genderInt = 3;

    // Map State string to int as per API
    const homeStateInt = stateMap[formData.homeState] || 0;
    const medicalCollegeStateInt = stateMap[formData.medicalCollegeState] || 0;

    // Build payload with exact API property names
    if (isValid) {
      const refId = generateReferenceId();
      setLoading(true);
      try {
        const payload = {
          ApplicantName: formData.applicantName,
          Gender: genderInt,
          ContactNumber: formData.contactNumber,
          AlternativeContactNumber: formData.altContact || "",
          EmailId: formData.email,
          HostInstituteAddress: formData.hostAddress,
          PassportPhoto: formData.passportPhoto
            ? await toBase64(formData.passportPhoto)
            : "",
          MentorName: formData.mentorName,
          MentorContactNumber: formData.mentorContact,
          MentorEmail: formData.mentorEmail,
          CoInvestigatorsNames: formData.coInvestigatorName,
          CoInvestigatorsContactNumber: formData.coInvestigatorContact,
          CoInvestigatorsEmail: formData.coInvestigatorEmail,
          MedicalCollegeName: formData.medicalCollegeName,
          MedicalCollegeAddress: formData.medicalCollegeAddress,
          MedicalCollegePincode: formData.medicalCollegePincode,
          BankAccountName: formData.bankName,
          BankBranchName: formData.branchName,
          BankAccountNumber: formData.accountNumber,
          BankIfscCode: formData.ifscCode,
          BankAddress: formData.bankAddress,
          PanNumber: formData.panNumber,
          BankDocuments: formData.bankDocuments
            ? await toBase64(formData.bankDocuments)
            : "",
          PanFile: formData.panFile ? await toBase64(formData.panFile) : "",
          AgreeShareResearchProgress: formData.shareReport === "Yes",
          AgreeAcknowledgeMetropolis: formData.acknowledge === "Yes",
          AgreeReturnFundsIfIncomplete: formData.refund === "Yes",
          AgreeTermsAndConditions: formData.agreeTerms,
          DeclarationConfirmation:formData.confirmDetails,

          // Fix: Convert state names to integers using the stateMap
          HomeState: formData.homeState, // Use the integer value from stateMap
          HomeDistrict: formData.homeDistrict,
          HomeCity: formData.homeCity,
          MedicalCollegeState: formData.medicalCollegeState, // Use the integer value from stateMap
          MedicalCollegeDistrict: formData.medicalCollegeDistrict,
          MedicalCollegeCity: formData.medicalCollegeCity,

          // Research specific fields
          ResearchCenter: formData.researchCenter,
          ResearchTitle: formData.researchTitle,
          StartDate: formData.startDate,
          EndDate: formData.endDate,
          NumberOfCases: formData.cases,
          StudyType: formData.studyType,
          ProposedBudget: formData.budget,

          // Convert files to base64
          ApprovalLetter: formData.approvalLetter
            ? await toBase64(formData.approvalLetter)
            : "",
          StudyDesign: formData.studyDesign
            ? await toBase64(formData.studyDesign)
            : "",
          CoverLetter: formData.coverLetter
            ? await toBase64(formData.coverLetter)
            : "",
          ResearchTemplate: formData.researchTemplate
            ? await toBase64(formData.researchTemplate)
            : "",
          ReferenceArticle: formData.referenceArticle
            ? await toBase64(formData.referenceArticle)
            : "",
          EthicsLetter: formData.ethicsLetter
            ? await toBase64(formData.ethicsLetter)
            : "",
          ApplicantCV: formData.applicantCV
            ? await toBase64(formData.applicantCV)
            : "",
          Signature: formData.signature
            ? await toBase64(formData.signature)
            : "",
          ReferencePublication: formData.referencePublication
            ? await toBase64(formData.referencePublication)
            : "",
          CreatedAt: new Date().toISOString(),
          StudentId: StudentId || "",
          Published: formData.published,
          PublicationLink: formData.publicationLink,
          WonBefore: formData.wonBefore,
          WinnerName: formData.winnerName,
          WinnerType: formData.winnerType,
          SiblingWon: formData.siblingWon,
          SiblingName: formData.siblingName,
          SiblingType: formData.siblingType,
          // Add the required request field
          request: true,
        };

        // console.log("AcademicResearchForm API payload ready to submit:", payload);
        // toast.info("Submitting your application...");

        const response = await axiosInstance.post(
          "api/Student/AcademicResearchForm",
          payload
        );
        if (response.data.Status === "200") {
          // Use the reference ID from the API response
          const referenceId = response.data.ReferenceId;

          toast.success("Application submitted successfully!");
          navigate("/success", {
            state: {
              referenceId: refId,
              name: formData.applicantName,
              email: formData.email,
              formType: "Academic Research Application",
            },
          });
        } else {
          toast.error(
            response.data.Message || "Application submission failed!"
          );
        }
      } catch (err) {
        console.error("Submission error:", err);
        if (
          err.response &&
          err.response.data &&
          err.response.data.Status === "400" &&
          err.response.data.Message &&
          err.response.data.Message.includes(
            "You are permitted to submit the academic application only once using this email ID."
          )
        ) {
          toast.error(err.response.data.Message);
        } else if (
          err.response &&
          err.response.data &&
          err.response.data.Status === "409"
        ) {
          toast.error(
            err.response.data.Message ||
              "Form already submitted for this email."
          );
        } else {
          toast.error(
            err.response.data.Message || "Submission failed. Please try again."
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };
  // Helper to convert file to base64
  function toBase64(file) {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  }
  const fieldRefs = {
    applicantName: useRef(),
    gender: useRef(),
    contactNumber: useRef(),
    email: useRef(),
    homeState: useRef(),
    homeDistrict: useRef(),
    homeCity: useRef(),
    hostAddress: useRef(),
    mentorName: useRef(),
    mentorContact: useRef(),
    mentorEmail: useRef(),
    coInvestigatorName: useRef(),
    coInvestigatorContact: useRef(),
    coInvestigatorEmail: useRef(),
    medicalCollegeName: useRef(),
    medicalCollegeAddress: useRef(),
    medicalCollegeState: useRef(),
    medicalCollegeDistrict: useRef(),
    medicalCollegeCity: useRef(),
    medicalCollegePincode: useRef(),
    bankName: useRef(),
    branchName: useRef(),
    accountNumber: useRef(),
    ifscCode: useRef(),
    bankAddress: useRef(),
    panNumber: useRef(),
    bankDocuments: useRef(),
    panFile: useRef(),
    agreeProgressReport: useRef(),
    agreeAcknowledgement: useRef(),
    agreeReturnFunds: useRef(),
    agreeTerms: useRef(),
    // Add more refs as needed for other required fields
  };
  // Helper function for detecting leading/trailing spaces
  function hasLeadingOrTrailingSpace(str) {
    return typeof str === "string" && str.trim() !== str;
  }

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed !== value) {
        // update local form state
        setFormData((prev) => ({ ...prev, [name]: trimmed }));
        // Show field-specific toast message
      }
    }

    // run validation after trimming
    setSubmitted(true);
    validate();
  };

  const validate = () => {
    let tempErrors = {};

    const requiredRegularFields = [
      "applicantName",
      "gender",
      "contactNumber",
      "email",
      "homeState",
      "homeDistrict",
      "homeCity",
      "mentorName",
      "mentorContact",
      "mentorEmail",
      "coInvestigatorName",
      "coInvestigatorContact",
      "coInvestigatorEmail",
      "medicalCollegeName",
      "medicalCollegeAddress",
      "medicalCollegeState",
      "medicalCollegeDistrict",
      "medicalCollegeCity",
      "medicalCollegePincode",
      "bankName",
      "branchName",
      "accountNumber",
      "ifscCode",
      "bankAddress",
      "panNumber",
      //  "researchCenter", "researchTitle", "startDate", "endDate",
      // "cases", "studyType", "budget", "shareReport", "acknowledge", "refund"
      "researchCenter",
      "researchTitle",
      "startDate",
      "endDate",
      "cases",
      "studyType",
      "budget",
      "shareReport",
      "acknowledge",
    ];

    // File fields need special handling
    const requiredFileFields = [
      "passportPhoto",
      "approvalLetter",
      "studyDesign",
      "coverLetter",
      "researchTemplate",
      "referenceArticle",
      "ethicsLetter",
      "applicantCV",
      "signature",
      "bankDocuments",
      "panFile",
    ];

    // Check regular fields
    requiredRegularFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        tempErrors[field] = "Required";
      }
    });

    // Check file fields differently - they might be null rather than undefined
    requiredFileFields.forEach((field) => {
      if (!formData[field]) {
        tempErrors[field] = "Required";
      }
    });

    // Name fields validation - only allow alphabets and spaces
    if (
      formData.applicantName &&
      !/^[A-Za-z ]+$/.test(formData.applicantName.trim())
    ) {
      tempErrors.applicantName = "Only alphabets and spaces allowed";
    }
    const phoneRegex = /^(\+91\s?)?\d{5}\s?\d{5}$/;
    if (formData.contactNumber && !phoneRegex.test(formData.contactNumber)) {
      tempErrors.contactNumber = "Use: +91 91522 11510 or 9152211510";
    }

    if (formData.altContact && !phoneRegex.test(formData.altContact)) {
      tempErrors.altContact = "Use: +91 91522 11510 or 9152211510";
    }
    const addressRegex = /^[a-zA-Z0-9\s,.#\-/]+$/;
    const addressFields = [
      "hostAddress",
      "medicalCollegeAddress" /* "bankAddress" */,
    ];

    addressFields.forEach((field) => {
      if (formData[field] && !addressRegex.test(formData[field])) {
        tempErrors[field] =
          "Only letters, numbers, spaces, and basic punctuation allowed";
      }
    });
    if (formData.mentorContact && !phoneRegex.test(formData.mentorContact)) {
      tempErrors.mentorContact = "Use: +91 91522 11510 or 9152211510";
    }
    if (formData.altContact && !phoneRegex.test(formData.altContact)) {
      tempErrors.altContact = "Use: +91 91522 11510 or 9152211510";
    }
   if (formData.coInvestigatorContact) {
  const phoneNumbers = formData.coInvestigatorContact.split(",").map(num => num.trim());
  const invalidNumbers = phoneNumbers.filter(
    (num) => !phoneRegex.test(num)
  );

  if (invalidNumbers.length > 0) {
    tempErrors.coInvestigatorContact = "Use format: +91 91522 11510 or 9152211510 (comma separated for multiple)";
  }
}

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailFields = ["email", "mentorEmail",];
    emailFields.forEach((field) => {
      if (formData[field]) {
        // Check for spaces in email
        if (!emailRegex.test(formData[field])) {
          tempErrors[field] = "Invalid email format (e.g., abc@test.com)";
        }
      }
    });
    const emailsRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

emailFields.forEach((field) => {
  if (formData[field]) {
    if (field === "coInvestigatorEmail") {
      // Allow multiple emails separated by commas
      const emails = formData[field].split(",").map((e) => e.trim());
      const invalidEmails = emails.filter((e) => !emailsRegex.test(e));

      if (invalidEmails.length > 0) {
        tempErrors[field] =
          "Invalid email format. Use: abc@test.com or multiple separated by commas.";
      }
    } else {
      // Single email validation for other fields
      if (!emailsRegex.test(formData[field])) {
        tempErrors[field] = "Invalid email format (e.g., abc@test.com)";
      }
    }
  }
});

    // Consent checkboxes
    if (!formData.agreeTerms) {
      tempErrors.agreeTerms = "Consent statements should be mandatory";
    }

    if (!formData.confirmDetails) {
      tempErrors.confirmDetails = "Consent statements should be mandatory";
    }

    // Radio button consents
    if (!formData.shareReport) {
      tempErrors.shareReport = "Please select an option";
    }

    if (!formData.acknowledge) {
      tempErrors.acknowledge = "Please select an option";
    }

    /*    if (!formData.refund) {
      tempErrors.refund = "Please select an option";
    } */

    // PAN validation
    // PAN validation - 5 letters + 4 digits + 1 letter
    // if (formData.panNumber) {
    //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    //   if (!panRegex.test(formData.panNumber)) {
    //     tempErrors.panNumber = "Invalid PAN format (e.g., ABCDE1234F)";
    //   }
    // }
    // Pincode validation - exactly 6 digits
    if (formData.medicalCollegePincode) {
      if (!/^\d{6}$/.test(formData.medicalCollegePincode)) {
        tempErrors.medicalCollegePincode = "Pincode must be exactly 6 digits";
      }
    }
    // Update the validation in your validate function:
    // if (formData.bankName && !/^[A-Za-z ]+$/.test(formData.bankName)) {
    //   tempErrors.bankName = "Only alphabets and spaces allowed";
    // }
    // Update the validation in your validate function:
    if (formData.startDate && formData.endDate) {
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);

      if (endDate < startDate) {
        tempErrors.endDate = "End Date must be ≥ Start Date";
      }
    }
    // Update the validation in your validate function:
    if (
      formData.medicalCollegeAddress &&
      !/^[a-zA-Z0-9\s,.#\-/]+$/.test(formData.medicalCollegeAddress)
    ) {
      tempErrors.medicalCollegeAddress =
        "Only letters, numbers, spaces, and basic punctuation allowed";
    }
    // Budget validation - only numbers and commas
    // Update the validation in your validate function:
    if (formData.budget && !/^\d+$/.test(formData.budget)) {
      tempErrors.budget = "Numbers only";
    }
    // Date validation
    if (formData.startDate && formData.endDate) {
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);

      if (endDate < startDate) {
        tempErrors.endDate = "End date must be after start date";
      }
    }
    // if (formData.accountNumber) {
    //   // Bank account numbers in India typically have 10-18 digits
    //   const accountRegex = /^\d{10,18}$/;
    //   if (!accountRegex.test(formData.accountNumber)) {
    //     tempErrors.accountNumber = "allow only number (10-18 digits without spaces)";
    //   }
    // }
    // URL validation for publicationLink
    if (formData.published === "Yes") {
      if (!formData.publicationLink || formData.publicationLink.trim() === "") {
        tempErrors.publicationLink = "link is required";
      } else if (
        !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
          formData.publicationLink
        )
      ) {
        tempErrors.publicationLink =
          "Please enter a valid URL (e.g., https://example.com)";
      }
    }

    // Winner Name validation
    if (formData.wonBefore === "Yes") {
      if (!formData.winnerName || formData.winnerName.trim() === "") {
        tempErrors.winnerName = "Please mention the name and year won";
      }
      if (!formData.winnerType || formData.winnerType.trim() === "") {
        tempErrors.winnerType = "Please select Scholarship or Research Grant";
      }
    }

    // Sibling Type validation
    if (formData.siblingWon === "Yes") {
      if (!formData.siblingName || formData.siblingName.trim() === "") {
        tempErrors.siblingName =
          "Please mention your sibling's name and year won";
      }
      if (!formData.siblingType || formData.siblingType.trim() === "") {
        tempErrors.siblingType =
          "Please select Scholarship or Research Grant for sibling";
      }
    }
    if (formData.mentorName && !/^[A-Za-z ]+$/.test(formData.mentorName)) {
      tempErrors.mentorName = "Only alphabets and spaces allowed";
    }
    // IFSC validation - 4 letters + 0 + 6 alphanumeric
    // if (formData.ifscCode) {
    //   const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    //   if (!ifscRegex.test(formData.ifscCode)) {
    //     tempErrors.ifscCode = "Invalid IFSC format (e.g., SBIN0123456)";
    //   }
    // }
    // Pincode validation (6 digits)
    if (
      formData.medicalCollegePincode &&
      !/^\d{6}$/.test(formData.medicalCollegePincode)
    ) {
      tempErrors.medicalCollegePincode = "Pincode should be exactly 6 digits";
    }

    // Proposed Budget: numbers and commas only
    if (
      formData.proposedBudget &&
      !/^\d+(,\d{3})*(\.\d{1,2})?$/.test(formData.proposedBudget)
    ) {
      tempErrors.proposedBudget = "Only numbers and commas allowed";
    }

    // Name as in Bank: only alphabets and spaces
    // if (formData.bankName && !/^[A-Za-z ]+$/.test(formData.bankName)) {
    //   tempErrors.bankName = "Only alphabets and spaces allowed";
    // }

    // Branch Name: only alphabets and spaces
    // if (formData.branchName && !/^[A-Za-z ]+$/.test(formData.branchName)) {
    //   tempErrors.branchName = "Only alphabets and spaces allowed";
    // }

    // Name of Mentor: only alphabets and spaces
    if (formData.mentorName && !/^[A-Za-z ]+$/.test(formData.mentorName)) {
      tempErrors.mentorName = "Only alphabets and spaces allowed";
    }

    // Name(s) of Co-investigator(s): only alphabets and spaces
 if (
  formData.coInvestigatorName &&
  !/^[A-Za-z ,]+$/.test(formData.coInvestigatorName)
) {
  tempErrors.coInvestigatorName = "Only alphabets, spaces, and commas allowed";
}

const nameFields = [
  "applicantName",
  "mentorName",
  "medicalCollegeName",
  // "bankName",
  // "branchName",
  "homeCity",
  "districtOfCollege",
  "cityOfCollege",
  "researchCenter",
];

nameFields.forEach((field) => {
  if (formData[field] && !/^[A-Za-z ]+$/.test(formData[field])) {
    tempErrors[field] = "Only letters and spaces allowed";
  }
});

    // Name/Address of College: alphanumeric for name, allow punctuation for address
    if (
      formData.medicalCollegeName &&
      !/^[A-Za-z0-9 .,'()-]+$/.test(formData.medicalCollegeName)
    ) {
      tempErrors.medicalCollegeName =
        "Only letters, numbers, spaces and . , ' ( ) - allowed";
    }
    if (formData.passportPhoto) {
      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(formData.passportPhoto.type)) {
        tempErrors.passportPhoto = "Only JPG and PNG files are allowed";
      }
      if (formData.passportPhoto.size > 10 * 1024 * 1024) {
        tempErrors.passportPhoto = "File must be ≤ 10MB";
      }
    }

    // Check all string fields for leading/trailing spaces
    Object.keys(formData).forEach((field) => {
      if (
        typeof formData[field] === "string" &&
        formData[field] &&
        hasLeadingOrTrailingSpace(formData[field])
      ) {
      }
    });
    // Study Start/End Date
    if (
      formData.startDate &&
      formData.endDate &&
      formData.endDate < formData.startDate
    ) {
      tempErrors.endDate =
        "End Date must be greater than or equal to Start Date";
    }

    // Published Grant URL (if present)
    if (
      formData.publishedGrantURL &&
      !/^https?:\/\/[^\s$.?#].[^\s]*$/.test(formData.publishedGrantURL)
    ) {
      tempErrors.publishedGrantURL = "Enter a valid URL";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // ...existing code...
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let updatedValue;

    // Handle checkboxes
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
      return;
    }

    // Handle file inputs
    if (type === "file") {
      const file = files[0];
      if (file) {
        // File size validation (5MB limit)
        if (file.size > 10 * 1024 * 1024) {
          toast.error("File must be ≤ 10MB");
          e.target.value = ""; // Clear the file input
          return;
        }

        // File type validation for images
        if (name === "passportPhoto") {
          const validTypes = ["image/jpeg", "image/png"];
          if (!validTypes.includes(file.type)) {
            toast.error("Only JPG and PNG files are allowed");
            e.target.value = ""; // Clear the file input
            return;
          }
        }

        setFormData({ ...formData, [name]: file });
      }
      setErrors((prev) => ({ ...prev, [name]: undefined }));
      return;
    }

    // Handle text-based inputs
    if (
      type === "text" ||
      type === "email" ||
      type === "tel" ||
      type === "textarea" ||
      name === "researchTitle" ||
      name === "applicantName" ||
      name === "mentorName" ||
      name === "coInvestigatorName" ||
      name === "medicalCollegeName" ||
      name === "budget"
    ) {
      // We allow spaces during typing (like "Shilpa A" with space between)
      // The trimming and toast happens in handleBlur when user finishes typing
      updatedValue = value;
    } else {
      updatedValue = value;
    }

    // Handle state selection which needs to update district options
    if (name === "homeState") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Store the state name
        homeDistrict: "", // Reset district when state changes
      }));

      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
        homeDistrict: undefined,
      }));
      return;
    }

    // Handle medical college state selection
    if (name === "medicalCollegeState") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Store the state name
        medicalCollegeDistrict: "", // Reset district when state changes
      }));

      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
        medicalCollegeDistrict: undefined,
      }));
      return;
    }

    // Handle all other inputs
    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container-fluid py-5">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: 200 }}
        >
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="form-container">
        <h2 className="text-center form-heading">
          <span className="green">Academic Research</span> Application
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="section-header">Basic Information</div>

          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name of the Applicant/Principal Investigator
                <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name of Applicant/Investigator"
                name="applicantName"
                value={formData.applicantName}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.applicantName}
              />
              {submitted && errors.applicantName && (
                <small className="text-danger">{errors.applicantName}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Gender<span className="required">*</span>
              </label>
              <select
                className="form-select"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                ref={fieldRefs.gender}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              {submitted && errors.gender && (
                <small className="text-danger">{errors.gender}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Contact Number<span className="required">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter 10-digit mobile number"
                name="contactNumber"
                value={formData.contactNumber}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.contactNumber}
              />
              {submitted && errors.contactNumber && (
                <small className="text-danger">{errors.contactNumber}</small>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Email ID
                <small class="text-muted me-1">
                  (This form can be submitted only once using this email ID)
                </small>
                <span className="required">*</span>
              </label>

              <input
                type="email"
                className="form-control"
                placeholder="Enter email ID"
                name="email"
                value={formData.email}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.email}
              />
              {submitted && errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Alternative Contact Number</label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter alternative contact number"
                name="altContact"
                value={formData.altContact}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.altContact}
              />
              {submitted && errors.altContact && (
                <small className="text-danger">{errors.altContact}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Address of Host Institute/University/Hospital
                <span className="required">*</span>
              </label>
              <textarea
                className="form-control"
                rows={1}
                placeholder="Enter host address"
                name="hostAddress"
                value={formData.hostAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.hostAddress}
              ></textarea>
              {submitted && errors.hostAddress && (
                <small className="text-danger">{errors.hostAddress}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Home State<span className="required">*</span>
              </label>
              <select
                className="form-select"
                name="homeState"
                value={formData.homeState || ""}
                onChange={handleChange}
                ref={fieldRefs.homeState}
              >
                <option value="">Select State</option>
                {indianStates.map((stateName) => (
                  <option key={stateName} value={stateName}>
                    {stateName}
                  </option>
                ))}
              </select>
              {submitted && errors.homeState && (
                <small className="text-danger">{errors.homeState}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Home District<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="homeDistrict"
                value={formData.homeDistrict || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.homeDistrict}
                placeholder="Enter district"
              />
              {submitted && errors.homeDistrict && (
                <small className="text-danger">{errors.homeDistrict}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Home City<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Please enter your home city"
                name="homeCity"
                value={formData.homeCity || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.homeCity}
              />
              {submitted && errors.homeCity && (
                <small className="text-danger">{errors.homeCity}</small>
              )}
            </div>

            <div className="col-md-4 mb-3 file-upload-wrapper">
              <label className="form-label">
                Upload Passport Size Photo<span className="required">*</span>
              </label>
              <div className="file-upload-wrapper">
                <label className="file-upload-btn">
                  <i className="fa fa-upload"></i>
                  Choose Photo
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    name="passportPhoto"
                    onChange={handleChange}
                  />
                </label>
                <small className="form-text text-muted">
                  Accepted formats: jpg, png, Max 10 MB
                </small>
                {/* Show selected file name if file is chosen */}
                {formData.passportPhoto && (
                  <div className="mt-1 text-success">
                    Selected file: {formData.passportPhoto.name}
                  </div>
                )}
                {submitted && errors.passportPhoto && (
                  <small className="text-danger d-block">
                    {errors.passportPhoto}
                  </small>
                )}
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Have you won MedEngage Scholarship/Research grant before?
              </label>
              <select
                className="form-select"
                name="wonBefore"
                value={formData.wonBefore}
                onChange={handleChange}
                ref={fieldRefs.wonBefore}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Have you published the Research Grant supported by Metropolis?
              </label>
              <select
                className="form-select"
                name="published"
                value={formData.published}
                onChange={handleChange}
                ref={fieldRefs.published}
              >
                <option value="">Select</option>
                <option value="Yes">Yes, I published</option>
                <option value="No">No</option>
              </select>
            </div>

            {/* Publication Link */}
            {formData.published === "Yes" && (
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Details of the published research with its link
                </label>
                <input
                  type="url"
                  className="form-control"
                  name="publicationLink"
                  onBlur={handleBlur}
                  placeholder="https://example.com"
                  value={formData.publicationLink}
                  onChange={handleChange}
                  ref={fieldRefs.publicationLink}
                />
                {submitted && errors.publicationLink && (
                  <small className="text-danger">
                    {errors.publicationLink}
                  </small>
                )}
              </div>
            )}

            {/* Winner Details */}
            {formData.wonBefore === "Yes" && (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    If yes, please mention the name and year won
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="winnerName"
                    onBlur={handleBlur}
                    placeholder="e.g. Raju-2025"
                    value={formData.winnerName}
                    onChange={handleChange}
                    ref={fieldRefs.winnerName}
                  />
                  {submitted && errors.winnerName && (
                    <small className="text-danger">{errors.winnerName}</small>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Was it a Scholarship or Research Grant?
                  </label>
                  <select
                    className="form-select"
                    name="winnerType"
                    value={formData.winnerType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={fieldRefs.winnerType}
                  >
                    <option value="">Select</option>
                    <option value="Scholarship">Scholarship</option>
                    <option value="Research Grant">Research Grant</option>
                  </select>
                </div>
              </div>
            )}

            {/* Sibling section */}

            <div className="col-md-12 mb-3">
              <label className="form-label">
                Did your sibling win a MedEngage Scholarship / Research Grant?
              </label>
              <select
                className="form-select"
                name="siblingWon"
                value={formData.siblingWon}
                onChange={handleChange}
                ref={fieldRefs.siblingWon}
                onBlur={handleBlur}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {/* Leave empty columns when siblingWon is not Yes */}
            {formData.siblingWon !== "Yes" && (
              <>
                <div className="col-md-4 mb-3"></div>
                <div className="col-md-4 mb-3"></div>
              </>
            )}

            {/* Sibling Details */}
            {formData.siblingWon === "Yes" && (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    If yes, please mention your Sibling name and year won
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="siblingName"
                    placeholder="e.g. Teju-2022"
                    value={formData.siblingName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={fieldRefs.siblingName}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Was it a Scholarship or Research Grant?
                  </label>
                  <select
                    className="form-select"
                    name="siblingType"
                    value={formData.siblingType}
                    onChange={handleChange}
                    ref={fieldRefs.siblingType}
                  >
                    <option value="">Select</option>
                    <option value="Scholarship">Scholarship</option>
                    <option value="Research Grant">Research Grant</option>
                  </select>
                </div>
              </div>
            )}

            <div className="section-header mt-2">
              Research Guide / Mentor Information
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name of Mentor/Guide<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your mentor"
                name="mentorName"
                value={formData.mentorName}
                onChange={handleChange}
                ref={fieldRefs.mentorName}
                onBlur={handleBlur}
              />
              {submitted && errors.mentorName && (
                <small className="text-danger">{errors.mentorName}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Contact Number of the Guide<span className="required">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter 10-digit mobile number"
                name="mentorContact"
                value={formData.mentorContact}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.mentorContact}
              />
              {submitted && errors.mentorContact && (
                <small className="text-danger">{errors.mentorContact}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Email ID of the Guide<span className="required">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email address"
                name="mentorEmail"
                value={formData.mentorEmail}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.mentorEmail}
              />
              {submitted && errors.mentorEmail && (
                <small className="text-danger">{errors.mentorEmail}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name(s) of Co-investigator(s)
                <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Name(s) of Co-investigator(s)"
                name="coInvestigatorName"
                value={formData.coInvestigatorName}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.coInvestigatorName}
              />
              {submitted && errors.coInvestigatorName && (
                <small className="text-danger">
                  {errors.coInvestigatorName}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Contact Number of Co-investigators
                <span className="required">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter 10-digit mobile number"
                name="coInvestigatorContact"
                value={formData.coInvestigatorContact}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.coInvestigatorContact}
              />
              {submitted && errors.coInvestigatorContact && (
                <small className="text-danger">
                  {errors.coInvestigatorContact}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Email ID of Co-investigators
                <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter email addresses (comma separated for multiple)"
                name="coInvestigatorEmail"
                value={formData.coInvestigatorEmail}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.coInvestigatorEmail}
              />
              {submitted && errors.coInvestigatorEmail && (
                <small className="text-danger">
                  {errors.coInvestigatorEmail}
                </small>
              )}
            </div>
          </div>
          <div className="section-header">Medical College Location Details</div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name of the Medical College<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name of the medical college"
                name="medicalCollegeName"
                value={formData.medicalCollegeName}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.medicalCollegeName}
              />
              {submitted && errors.medicalCollegeName && (
                <small className="text-danger">
                  {errors.medicalCollegeName}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Address of the Medical College
                <span className="required">*</span>
              </label>
              <textarea
                rows={1}
                className="form-control"
                placeholder="Enter address of the medical college"
                name="medicalCollegeAddress"
                value={formData.medicalCollegeAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.medicalCollegeAddress}
              ></textarea>
              {submitted && errors.medicalCollegeAddress && (
                <small className="text-danger">
                  {errors.medicalCollegeAddress}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                State of Medical College<span className="required">*</span>
              </label>
              <select
                className="form-select"
                name="medicalCollegeState"
                value={formData.medicalCollegeState || ""}
                onChange={handleChange}
                ref={fieldRefs.medicalCollegeState}
              >
                <option value="">Select State</option>
                {indianStates.map((stateName) => (
                  <option key={stateName} value={stateName}>
                    {stateName}
                  </option>
                ))}
              </select>
              {submitted && errors.medicalCollegeState && (
                <small className="text-danger">
                  {errors.medicalCollegeState}
                </small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                District of Medical College<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="medicalCollegeDistrict"
                value={formData.medicalCollegeDistrict || ""}
                onChange={handleChange}
                ref={fieldRefs.medicalCollegeDistrict}
                placeholder="Enter district"
              />
              {submitted && errors.medicalCollegeDistrict && (
                <small className="text-danger">
                  {errors.medicalCollegeDistrict}
                </small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                City of Medical College<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter the city name where your college is located"
                name="medicalCollegeCity"
                value={formData.medicalCollegeCity || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.medicalCollegeCity}
              />
              {submitted && errors.medicalCollegeCity && (
                <small className="text-danger">
                  {errors.medicalCollegeCity}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Pincode<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Pincode"
                name="medicalCollegePincode"
                value={formData.medicalCollegePincode}
                onChange={handleChange}
                ref={fieldRefs.medicalCollegePincode}
              />
              {submitted && errors.medicalCollegePincode && (
                <small className="text-danger">
                  {errors.medicalCollegePincode}
                </small>
              )}
            </div>
          </div>
          <div className="section-header mb-3">Research Details</div>

          <div className="row mb-3">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Center of research<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter research center"
                name="researchCenter"
                value={formData.researchCenter}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.researchCenter}
              />
              {submitted && errors.researchCenter && (
                <small className="text-danger">{errors.researchCenter}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Approval letter from host Institute
                <span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="approvalLetter"
                onChange={handleChange}
                ref={fieldRefs.approvalLetter}
              />
              {submitted && errors.approvalLetter && (
                <small className="text-danger">{errors.approvalLetter}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Title of the research study<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter research topic"
                name="researchTitle"
                value={formData.researchTitle}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.researchTitle}
              />
              {submitted && errors.researchTitle && (
                <small className="text-danger">{errors.researchTitle}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Start Date<span className="required">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.startDate}
              />
              {submitted && errors.startDate && (
                <small className="text-danger">{errors.startDate}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                End Date<span className="required">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.endDate}
              />
              {submitted && errors.endDate && (
                <small className="text-danger">{errors.endDate}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Number of cases (Proposed)<span className="required">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Number of cases"
                name="cases"
                value={formData.cases}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.cases}
              />
              {submitted && errors.cases && (
                <small className="text-danger">{errors.cases}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Type of Study<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter study type"
                name="studyType"
                onBlur={handleBlur}
                value={formData.studyType}
                onChange={handleChange}
                ref={fieldRefs.studyType}
              />
              {submitted && errors.studyType && (
                <small className="text-danger">{errors.studyType}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Study Design<span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="studyDesign"
                onChange={handleChange}
                ref={fieldRefs.studyDesign}
              />
              {submitted && errors.studyDesign && (
                <small className="text-danger">{errors.studyDesign}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Cover letter <small>(include aims & objectives)</small>
                <span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="coverLetter"
                onChange={handleChange}
                ref={fieldRefs.coverLetter}
              />
              {submitted && errors.coverLetter && (
                <small className="text-danger">{errors.coverLetter}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Research template<span className="required">*</span>{" "}
                <a
                  href="/Research-Proposal-Template-under-CSR.pptx"
                  className="ms-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click to view the research template
                </a>
              </label>
              <input
                type="file"
                className="form-control"
                name="researchTemplate"
                onChange={handleChange}
                ref={fieldRefs.researchTemplate}
              />
              {submitted && errors.researchTemplate && (
                <small className="text-danger">{errors.researchTemplate}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Reference article<span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="referenceArticle"
                onChange={handleChange}
                ref={fieldRefs.referenceArticle}
              />
              {submitted && errors.referenceArticle && (
                <small className="text-danger">{errors.referenceArticle}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Ethics Committee approval letter
                <span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="ethicsLetter"
                onChange={handleChange}
                ref={fieldRefs.ethicsLetter}
              />
              {submitted && errors.ethicsLetter && (
                <small className="text-danger">{errors.ethicsLetter}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Proposed budget<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter proposed budget"
                name="budget"
                value={formData.budget}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.budget}
              />
              {submitted && errors.budget && (
                <small className="text-danger">{errors.budget}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Reference publication / paper
              </label>
              <input
                type="file"
                className="form-control"
                name="referencePublication"
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.referencePublication}
              />
              {submitted && errors.referencePublication && (
                <small className="text-danger">
                  {errors.referencePublication}
                </small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                CV of the applicant<span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="applicantCV"
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.applicantCV}
              />
              {submitted && errors.applicantCV && (
                <small className="text-danger">{errors.applicantCV}</small>
              )}
            </div>
          </div>

          <div className="row col-md-12 mb-3 file-upload-wrapper">
            <label className="form-label">
              Signature of Applicant
              <span className="small text-muted">
                (Accepted formats: .jpg, .png,.jpeg. Max size: 10 MB){" "}
              </span>
              <span className="text-danger">*</span>
            </label>

            <div className="file-upload-wrapper">
              <label className="file-upload-btn">
                <i className="fa fa-upload"></i> Choose Signature
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  name="signature"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.signature}
                />
              </label>
              <small className="form-text text-muted">
                (Accepted formats: .jpg,.png, .jpeg, Max 10 MB)
              </small>
              {/* Show selected file name */}
              {formData.signature && (
                <div className="mt-1 text-success">
                  Selected file: {formData.signature.name}
                </div>
              )}
              {submitted && errors.signature && (
                <small className="text-danger d-block">
                  {errors.signature}
                </small>
              )}
            </div>
          </div>

          <div className="section-header">Bank Account Details</div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name as in Bank<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name as per bank record"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.bankName}
              />
              {submitted && errors.bankName && (
                <small className="text-danger">{errors.bankName}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Branch Name<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter branch name"
                name="branchName"
                value={formData.branchName}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.branchName}
              />
              {submitted && errors.branchName && (
                <small className="text-danger">{errors.branchName}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Account Number<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter account number"
                name="accountNumber"
                value={formData.accountNumber}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.accountNumber}
              />
              {submitted && errors.accountNumber && (
                <small className="text-danger">{errors.accountNumber}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                IFSC Code<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter IFSC code"
                name="ifscCode"
                value={formData.ifscCode}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.ifscCode}
              />
              {submitted && errors.ifscCode && (
                <small className="text-danger">{errors.ifscCode}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Bank Address<span className="required">*</span>
              </label>
              <textarea
                rows={1}
                className="form-control"
                placeholder="Enter bank address"
                name="bankAddress"
                value={formData.bankAddress}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.bankAddress}
              ></textarea>
              {submitted && errors.bankAddress && (
                <small className="text-danger">{errors.bankAddress}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                PAN Number<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter PAN number"
                name="panNumber"
                onBlur={handleBlur}
                value={formData.panNumber}
                onChange={handleChange}
                ref={fieldRefs.panNumber}
              />
              {submitted && errors.panNumber && (
                <small className="text-danger">{errors.panNumber}</small>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Bank Passbook
                <span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="bankDocuments"
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.bankDocuments}
              />
              {submitted && errors.bankDocuments && (
                <small className="text-danger">{errors.bankDocuments}</small>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                PAN Card
                <span className="required">*</span>
              </label>
              <input
                type="file"
                className="form-control"
                name="panFile"
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.panFile}
              />
              {submitted && errors.panFile && (
                <small className="text-danger">{errors.panFile}</small>
              )}
            </div>
          </div>
          <div className="col-12 mt-2">
            <span className="small text-success">
              Note: Bank Details will be used only when candidates win the
              scholarship. The student will be informed of their winning and
              post their win, funds would be transferred. The information will
              be used only for this scholarship.
            </span>
          </div>
          <div className="section-header">Agreements / Terms</div>
          <div className="col-md-12 mb-3">
            <label className="form-label">
              Applicant should agree to share the Progress of Research Report
              with Metropolis.
            </label>
            <div>
              <label className="me-3">
                <input
                  type="radio"
                  name="shareReport"
                  value="Yes"
                  checked={formData.shareReport === "Yes"}
                  onChange={handleChange}
                  ref={fieldRefs.shareReport}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="shareReport"
                  value="No"
                  checked={formData.shareReport === "No"}
                  onChange={handleChange}
                  ref={fieldRefs.shareReport}
                />{" "}
                No
              </label>
            </div>
            {submitted && errors.shareReport && (
              <small className="text-danger">{errors.shareReport}</small>
            )}
          </div>

          {/* Acknowledge */}
          <div className="col-md-12 mb-3">
            <label className="form-label">
              Applicant should agree to acknowledge Metropolis Health Care
              Limited in their Published Research.
            </label>
            <div>
              <label className="me-3">
                <input
                  type="radio"
                  name="acknowledge"
                  value="Yes"
                  checked={formData.acknowledge === "Yes"}
                  onChange={handleChange}
                  ref={fieldRefs.acknowledge}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="acknowledge"
                  value="No"
                  checked={formData.acknowledge === "No"}
                  onChange={handleChange}
                  ref={fieldRefs.acknowledge}
                />{" "}
                No
              </label>
            </div>
            {submitted && errors.acknowledge && (
              <small className="text-danger">{errors.acknowledge}</small>
            )}
          </div>

          {/* Refund if not completed */}
          <div className="mb-3">
            <label className="form-label">
              Metropolis desires that candidates submit the final report latest
              by February end or March 1st week . Post this management reserves
              the right to utilize the leftover research funds for other
              productive purposes under MedEngage. Full payment to the student
              will be made only after submission of the complete report, data,
              and manuscript.
            </label>
            <div>
              <label className="me-3">
                <input
                  type="radio"
                  name="refund"
                  value="Yes"
                  checked={formData.refund === "Yes"}
                  onChange={handleChange}
                  ref={fieldRefs.refund}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="refund"
                  value="No"
                  checked={formData.refund === "No"}
                  onChange={handleChange}
                  ref={fieldRefs.refund}
                />{" "}
                No
              </label>
            </div>
            {submitted && errors.refund && (
              <small className="text-danger">{errors.refund}</small>
            )}
          </div>

          {/* Terms & Conditions */}
          <div className="form-check mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              id="agreeTerms"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={handleChange}
              ref={fieldRefs.agreeTerms}
            />
            <label className="form-check-label" htmlFor="agreeTerms">
              I agree to{" "}
              <a
                href="/Final_TermsConditions_MedEngage2.0_8.10.24.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>{" "}
              of the programme
            </label>
            {submitted && errors.agreeTerms && (
              <small className="text-danger">{errors.agreeTerms}</small>
            )}
          </div>

          {/* Confirm Details */}
          <div className="form-check mb-4">
            <input
              type="checkbox"
              className="form-check-input"
              id="confirmDetails"
              name="confirmDetails"
              checked={formData.confirmDetails}
              onChange={handleChange}
              ref={fieldRefs.confirmDetails}
            />

            <label className="form-check-label" htmlFor="confirmDetails">
              I confirm that all details provided in this application form are
              true to the best of my knowledge
            </label>
            {submitted && errors.confirmDetails && (
              <small className="text-danger">{errors.confirmDetails}</small>
            )}
          </div>
          <div class="alert alert-info d-flex align-items-center" role="alert">
            <i class="fa fa-sticky-note me-2" aria-hidden="true"></i>
            <strong>Note:</strong> Please review the form carefully before
            submitting.
          </div>

          <div className="text-center mt-3">
            <button
              type="submit"
              className="btn btn-outline-success submit-btn rounded-3"
              disabled={loading}
            >
              {loading ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Submitting...
                </span>
              ) : (
                <span>
                  <i className="fa fa-paper-plane me-2"></i>Submit Application
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AcademicResearchForm;
